import { render } from "./reduction.vue?vue&type=template&id=1867727d"
import script from "./reduction.vue?vue&type=script&lang=js"
export * from "./reduction.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/reduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1867727d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1867727d', __exports__)) {
    console.log('reload')
    api.reload('1867727d', __exports__)
  }
  
  module.hot.accept("./reduction.vue?vue&type=template&id=1867727d", () => {
    console.log('re-render')
    api.rerender('1867727d', render)
  })

}


export default __exports__